import styled from "styled-components";
import { device } from "responsive";

export const InfoIconStyled = styled.div`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-left: 15px;
  cursor: pointer;

  @media ${device.xs} {
    margin-left: 10px;
  }
`;
